import React from 'react';

import Icon from '../Icon';

export const RememberHeatingProfileOnIcon = (props) => {
    return (
        <Icon width='48' height='48' viewBox='0 0 32 32' fill='none' {...props}>
            <path
                d='M21.593 26.1046L15.9999 22.0767L10.4069 26.1046C9.25558 26.9324 7.6521 26.1115 7.6521 24.6924V7.65239C7.6521 6.50108 8.58775 5.56543 9.73906 5.56543H22.2608C23.4121 5.56543 24.3478 6.50108 24.3478 7.65239V24.6924C24.3478 26.1115 22.7443 26.9324 21.593 26.1046ZM15.9999 20.362L22.9564 25.3706V6.95673H9.0434V25.3706L15.9999 20.362Z'
                className='fill-color-slate-gray group-[.active]:fill-color-slate-gray dark:fill-color-romance'
            />
        </Icon>
    );
};
